export default __webpack_public_path__ + "static/media/plain-sticker-B.1e29fd31.png";